import React from 'react'
import {BsPatchCheckFill} from 'react-icons/bs'
import './Experience.css'
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';

const Experience = () => {






  const { ref, inView } = useInView({
    threshold: 0.4, // Trigger animation when the component is at least 50% visible
    triggerOnce: false // Trigger animation every time the component comes into view
  });

  // Use `useAnimation` to trigger the animation
  const animation = useAnimation();

  // Define the animation
  const leftVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1.5 } }
  };
  const topVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };

  

  // Use `useEffect` to trigger the animation when the component comes into view
  useEffect(() => {
    if (inView) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [inView, animation]);











  return (
    <section>
      <motion.div ref={ref} className='experience__section'variants={topVariants} 
          initial="hidden"
          animate={animation}>
      <h5 className='experience__h5'>What skills i have </h5>
      <h2 className='experience__h2'>My Experience</h2>

     <motion.div className="container experience__container" variants={leftVariants} 
          initial="hidden"
          animate={animation}>
      <motion.div className="experiance__frontend" >
        <h3>Frontend Development</h3>
        <div className="experience__content">
          <article className='experience__details'> 
          <div class='experience__detail-item'>
                  <BsPatchCheckFill className='experience__details-icons'/>
                  <div>
                      <h4>HTML</h4>
                      <small className='text-light'>Experienced</small>
                  </div>
              </div>
          </article>
          <article className='experience__details'>
          <div class='experience__detail-item'>
        <BsPatchCheckFill className='experience__details-icons'/>
        <div>
            <h4>CSS</h4>
            <small className='text-light'>Experienced</small>
        </div>
    </div>
            
          </article>
          <article className='experience__details'>
          <div class='experience__detail-item'>
        <BsPatchCheckFill className='experience__details-icons'/>
        <div>
            <h4>JavaScript</h4>
            <small className='text-light'>Experienced</small>
        </div>
    </div>
          </article>
          <article className='experience__details'>
          <div class='experience__detail-item'>
        <BsPatchCheckFill className='experience__details-icons'/>
        <div>
            <h4>Bootstrap</h4>
            <small className='text-light'>Experienced</small>
        </div>
    </div>
          </article>
          <article className='experience__details'>
          <div class='experience__detail-item'>
        <BsPatchCheckFill className='experience__details-icons'/>
        <div>
            <h4>React JS</h4>
            <small className='text-light'>Experienced</small>
        </div>
    </div>
          </article>
          <article className='experience__details'>
            < BsPatchCheckFill className='experience__details-icons'/>
            <div>
            <h4>Tailwind</h4>
            <small className='text-light'>Experienced</small>
            </div>
          </article>
        </div>
      </motion.div>


      <div className="experience__backend">
      <h3>Backend Development</h3>
        <div className="experience__content">
          <article className='experience__details'>
            < BsPatchCheckFill className='experience__details-icons'/>
            <div>
            <h4>Node JS</h4>
            <small className='text-light'>Experienced</small>

            </div>
          </article>
          <article className='experience__details'>
            < BsPatchCheckFill className='experience__details-icons'/>
            <div>
            <h4>PHP</h4>
            <small className='text-light'>Intermediate</small>
            </div>
          </article>
          <article className='experience__details'>
            < BsPatchCheckFill className='experience__details-icons'/>
            <div>
            <h4>MongoDB</h4>
            <small className='text-light'>Intermediate</small>
            </div>
          </article>
          <article className='experience__details'>
            < BsPatchCheckFill className='experience__details-icons'/>
            <div>
            <h4>Python JS</h4>
            <small className='text-light'>Basic</small>
            </div>
          </article>
          <article className='experience__details'>
            < BsPatchCheckFill className='experience__details-icons'/>
            <div>
            <h4>MySQL</h4>
            <small className='text-light'>Experienced</small>
            </div>
          </article>
        </div>

      </div>
     </motion.div>
     </motion.div>
    </section>
  )
}

export default Experience
